import React from "react";
import { connect } from "react-redux";
import {
  fetchEquipmentIOTData,
  setEqpIotDataError,
} from "../../application_actions";
import { bindActionCreators } from "redux";

const RetryFetch = ({
  fetchEquipmentIOTData,
  setEqpIotDataError,
  internetStatus,
  retryText,
}) => {
  const retry = () => {
    setEqpIotDataError("");
    fetchEquipmentIOTData(app.KEN);
  };

  return (
    <>
      <button
        className={"retry-fetch" + (!internetStatus ? " disabled" : "")}
        onClick={retry}
        disabled={!internetStatus}
      >
        {retryText}
      </button>
    </>
  );
};

function mapStateToProps({ app, i18n }) {
  return {
    retryText: i18n.strings.Common.retry,
    internetStatus: app.internetStatus,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { fetchEquipmentIOTData, setEqpIotDataError },
    dispatch
  );
}

const Retry = connect(mapStateToProps, mapDispatchToProps)(RetryFetch);
export default Retry;
